import { StyleSheet, View } from 'react-native';
import { Controller, FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
	Button,
	FormInput,
	HelpMarkIcon,
	HoverTextTooltip,
	Text,
	Toggle,
	spacing,
} from '@pletly/ui';
import { TeamFormMethods } from './useTeamForm';

type FormProps = { formMethods: TeamFormMethods } & (PropsCreate | PropsEdit);

type PropsCreate = {
	type?: 'create';
};

type PropsEdit = {
	type: 'edit';
	disabledTogglePostsScreening?: boolean;
};

export const TeamForm = ({ formMethods, ...props }: FormProps) => {
	const { t } = useTranslation();

	return (
		<FormProvider {...formMethods}>
			<FormInput
				label={t('teams.form.label-name')}
				placeholder={t('teams.form.label-name')}
				name="name"
			/>
			{props.type === 'edit' && (
				<View style={styles.toggleContainer}>
					<Text category="c1">{t('teams.form.label-posts-screening')}</Text>
					<Controller
						name="postsScreening"
						control={formMethods.control}
						disabled={props.disabledTogglePostsScreening}
						render={({ field: { onChange, value, disabled } }) => (
							<View style={styles.toggle}>
								<Toggle checked={value} onChange={onChange} disabled={disabled} />
								{disabled && (
									<HoverTextTooltip
										content={t('teams.form.post-screening-disabled-info')}
										style={styles.tooltip}
										position="right"
									>
										<HelpMarkIcon />
									</HoverTextTooltip>
								)}
							</View>
						)}
					/>
				</View>
			)}
		</FormProvider>
	);
};

export const TeamFormActions = ({
	onCancel,
	onSubmit,
}: {
	onCancel: () => unknown;
	onSubmit: () => unknown;
}) => {
	const { t } = useTranslation();

	return (
		<View style={styles.buttons}>
			<Button variant="outline" color="primary" onPress={onCancel} style={styles.button}>
				{t('common.cancel')}
			</Button>
			<Button variant="filled" color="primary" onPress={onSubmit} style={styles.button}>
				{t('common.save')}
			</Button>
		</View>
	);
};

const styles = StyleSheet.create({
	button: {
		flex: 1,
	},
	buttons: {
		flexDirection: 'row',
		gap: spacing(2),
		flex: 1,
	},
	toggleContainer: {
		alignItems: 'flex-start',
		gap: spacing(),
	},
	toggle: {
		flexDirection: 'row',
		gap: spacing(),
		alignItems: 'center',
	},
	tooltip: {
		width: 300,
	},
});
